let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("k8jK1")).then(() => parcelRequire('glnls'));